import React, {useEffect, useState} from "react";
import FavButton from "../../konduit/components/FavButton";
import Refresh from "./Refresh";

const WhatToDo = ({data, prefix}) => {

    const [listing1, setListing1] = useState(null);
    const [listing2, setListing2] = useState(null);
    const [listing3, setListing3] = useState(null);

    useEffect(() => {
        shuffleListings(1);
        shuffleListings(2);
        shuffleListings(3);
    }, []);

    const shuffleAll = () => {
        shuffleListings(1);
        shuffleListings(2);
        shuffleListings(3);
    }

    const getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    }

    const shuffleListings = (col) => {

        let listings = [];
        if (col === 1) {
            listings = data.listings1;
        }
        if (col === 2) {
            listings = data.listings2;
        }
        if (col === 3) {
            listings = data.listings3;
        }

        if (listings.length) {
            const index = getRandomInt(listings.length - 1);
            if (col === 1) {
                setListing1(listings[index]);
            }
            if (col === 2) {
                setListing2(listings[index]);
            }
            if (col === 3) {
                setListing3(listings[index]);
            }
        }
    }

    if (!listing1 && !listing2 && !listing3) {
        return '';
    }

    return <div className="element__body what-to-do__body">

        <div className="what-to-do__col">
            <div className="what-to-do__col__title" data-fade="down">
                <h3>{data.title1}</h3>
                {!!data.te_reo_title1 && <p>{data.te_reo_title1}</p>}
            </div>

            {!!listing1 && <div className="what-to-do__col__listing">
                <div className="listing-card" data-fade="down">
                    <div className="listing-card__reshuffle" onClick={() => { shuffleListings(1) }}>
                        <Refresh />
                    </div>
                    <FavButton id={listing1.Identifier} />
                    <a href={`${prefix}/listing/${listing1.URLSegment}`} target="_self" className="listing-card__inner">
                        <div className="listing-card__image"
                             style={{
                                 backgroundImage: `url("${listing1.MainImage.Sized}")`
                             }}
                        />
                        <div className="listing-card__body"><h3>{listing1.Title}</h3></div>
                    </a>
                </div>
            </div>}
        </div>
        <div className="what-to-do__col">
            <div className="what-to-do__col__title" data-fade="down">
                <h3>{data.title2}</h3>
                {!!data.te_reo_title2 && <p>{data.te_reo_title2}</p>}
            </div>

            {!!listing2 && <div className="what-to-do__col__listing">
                <div className="listing-card" data-fade="down">
                    <div className="listing-card__reshuffle" onClick={() => { shuffleListings(2) }}>
                        <Refresh />
                    </div>
                    <FavButton id={listing2.Identifier} />
                    <a href={`${prefix}/listing/${listing2.URLSegment}`} target="_self" className="listing-card__inner">
                        <div className="listing-card__image"
                             style={{
                                 backgroundImage: `url("${listing2.MainImage.Sized}")`
                             }}
                        />
                        <div className="listing-card__body"><h3>{listing2.Title}</h3></div>
                    </a>
                </div>
            </div>}
        </div>
        <div className="what-to-do__col">
            <div className="what-to-do__col__title" data-fade="down">
                <h3>{data.title3}</h3>
                {!!data.te_reo_title3 && <p>{data.te_reo_title3}</p>}
            </div>

            {!!listing3 && <div className="what-to-do__col__listing">
                <div className="listing-card" data-fade="down">
                    <div className="listing-card__reshuffle" onClick={() => { shuffleListings(3) }}>
                        <Refresh />
                    </div>
                    <FavButton id={listing3.Identifier} />
                    <a href={`${prefix}/listing/${listing3.URLSegment}`} target="_self" className="listing-card__inner">
                        <div className="listing-card__image"
                             style={{
                                 backgroundImage: `url("${listing3.MainImage.Sized}")`
                             }}
                        />
                        <div className="listing-card__body"><h3>{listing3.Title}</h3></div>
                    </a>
                </div>
            </div>}
        </div>

        <div className={'what-to-do__action'}>
            <a href={'#'} className={'btn btn--solid btn--solid--navy'} onClick={(e) => {e.preventDefault(); shuffleAll();}}>
                Refresh all listings
                <Refresh />
            </a>
        </div>

    </div>

}

export default WhatToDo;
